import cvModule from "@techstark/opencv-js";


/** Cached promise so OpenCV initializes once; multiple callers reuse the same instance. */
let cvPromise = null;
/**
 * Get the OpenCV instance.
 * @returns {Promise<{ cv: typeof cvModule }>}
 */
export default async function getOpenCv() {
    if (cvPromise) return cvPromise;
    cvPromise = (async () => {
        let cv;
        if (cvModule instanceof Promise) {
            cv = await cvModule;
        } else {
            await new Promise((resolve) => {
                cvModule.onRuntimeInitialized = () => resolve();
            });
            cv = cvModule;
        }
        return { cv };
    })();
    return cvPromise;
}
